
import React from 'react'
import { YAxis, Legend, XAxis, Area, AreaChart, ScatterChart, Scatter, LabelList, CartesianGrid, LineChart, Line, Tooltip} from "recharts";


const Product = () => {
  


    return (


     <div >
        
     </div>
    )
}

export default Product
